import Handsontable from 'handsontable'
import { createRoot } from 'react-dom/client'
import { ReactMultiSelect as ReactMultiSelectPrev } from './components/multi-select'
import { ReactMultiSelect } from './components/multiSelect'

let isFeatureChipsUIListsEnabled = false

export class MultiSelectEditor extends Handsontable.editors.TextEditor {
  constructor(props) {
    super(props)

    this.localdata = {
      selected: [],
    }
  }

  rerenderReact() {
    const options = this.cellProperties.source.map(item => {
      return { value: item, label: item }
    })

    this.parent = document.getElementById('react')

    if (!this.root) {
      this.root = createRoot(this.parent)
    }

    if (isFeatureChipsUIListsEnabled) {
      this.root.render(
        <ReactMultiSelect
          data={this.localdata}
          updateData={this.updateData}
          options={options}
          selected={this.localdata.selected}
          row={this.row}
          close={this.handleClose}
          parent={this.TD}
        />,
      )
    } else {
      this.root.render(
        <ReactMultiSelectPrev
          data={this.localdata}
          updateData={this.updateData}
          options={options}
          selected={this.localdata.selected}
          row={this.row}
          close={this.handleClose}
          parent={this.TD}
        />,
      )
    }
  }

  prepare() {
    super.prepare(...arguments)
  }

  open() {
    this.hot.unlisten()

    this.parent = document.getElementById('react')

    if (!this.parent) {
      this.TEXTAREA_REACT = document.createElement('div')
      this.TEXTAREA_REACT.setAttribute('id', 'react')
      this.TEXTAREA_PARENT.appendChild(this.TEXTAREA_REACT)
      this.TEXTAREA_PARENT.className = `${this.TEXTAREA_PARENT.className} react`
      this.parent = this.TEXTAREA_PARENT
    }

    const checked = []
    const currentlyChecked = this.originalValue
      ? this.originalValue.split(this.cellProperties.divider)
      : []
    this.cellProperties.source.forEach(item => {
      if (currentlyChecked.includes(item)) {
        checked.push(item)
      }
    })

    const options = this.cellProperties.source.map(item => {
      return { value: item, label: item }
    })

    const selected = checked.map(item => {
      return { value: item, label: item }
    })
    this.localdata.selected = selected

    this.textareaStyle = this.TEXTAREA.style
    this.textareaStyle.width = 0
    this.textareaStyle.height = 0
    this.textareaStyle.minWidth = 0
    this.textareaStyle.maxWidth = 0

    this.textareaReactStyle = this.TEXTAREA_REACT.style
    this.textareaReactStyle.top = 2
    this.textareaReactStyle.position = 'absolute'
    this.textareaReactStyle.width = '100%'
    this.textareaReactStyle.height = 350

    this.TEXTAREA_PARENT.style.width = `${this.TD.getClientRects()[0]?.width}px`
    // this.TEXTAREA_PARENT.appendChild(this.popover);

    this.onBeforeKeyDown = function (event) {
      // this shouldn't work. The error in javascript makes this work though. Wierd AF.
      switch (event.keyCode) {
        case Handsontable.helper.keyCode?.ARROW_UP:
          event.stopImmediatePropagation() // prevent EditorManager from processing this event
          event.preventDefault() // prevent browser from scrolling the page up
          break

        case Handsontable.helper.keyCode?.ARROW_DOWN:
          event.stopImmediatePropagation() // prevent EditorManager from processing this event
          event.preventDefault() // prevent browser from scrolling the page up
          break
      }
    }

    this.instance.addHook('beforeKeyDown', this.onBeforeKeyDown)

    this.root = createRoot(this.parent)

    if (isFeatureChipsUIListsEnabled) {
      this.root.render(
        <ReactMultiSelect
          data={this.localdata}
          updateData={this.updateData}
          options={options}
          selected={selected}
          row={this.row}
          close={this.handleClose}
          parent={this.TD}
        />,
      )
    } else {
      this.root.render(
        <ReactMultiSelectPrev
          data={this.localdata}
          updateData={this.updateData}
          options={options}
          selected={selected}
          row={this.row}
          close={this.handleClose}
          parent={this.TD}
        />,
      )
    }

    this.refreshDimensions() // need it instantly, to prevent https://github.com/handsontable/handsontable/issues/348
    this.showEditableElement()

    const self = this
    this.handleClose = function (nextLine) {
      self.finishEditing()
      self.close()
      self.TD?.focus()
      // self.instance.deselectCell();
      if (nextLine) {
        if (self.col + 1 == self.instance.countCols()) {
          nextLine === 'TAB'
            ? self.instance.selectCell(self.row + 1, 0)
            : self.instance.selectCell(self.row + 1, self.col)
        } else {
          nextLine === 'TAB'
            ? self.instance.selectCell(self.row, self.col + 1)
            : self.instance.selectCell(self.row + 1, self.col)
        }
      }
    }

    this.updateData = function (data) {
      self.localdata = data
      self.rerenderReact()
    }

    this.rerenderReact()
    super.open()
  }

  getValue() {
    const val = this.localdata?.selected?.length
      ? this.localdata.selected
          .map(item => {
            return item.value
          })
          .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()))
          .join(this.cellProperties.divider)
      : ''
    return val
  }

  setValue(value) {
    this.TEXTAREA.value = value
  }

  focus() {
    // don't
  }

  finishEditing(restoreOriginalValue, ctrlDown, callback) {
    super.finishEditing(restoreOriginalValue, ctrlDown, callback)

    if (this.root) {
      this.root.unmount()
      this.root = null
    }
    if (this.parent && this.parent.parentNode) {
      this.parent.parentNode.removeChild(this.parent)
      this.parent = null
    }
  }

  close() {
    this.instance.removeHook('beforeKeyDown', this.onBeforeKeyDown)
    if (!this.instance.rootElement) {
      return
    }
    // this.state = 'STATE_FINISHED'

    super.close()
  }

  createElements() {
    super.createElements()
    this.TEXTAREA_REACT = document.createElement('div')
    this.TEXTAREA_REACT.setAttribute('id', 'react')
    this.TEXTAREA_PARENT.appendChild(this.TEXTAREA_REACT)
    this.TEXTAREA_PARENT.className = `${this.TEXTAREA_PARENT.className} react`
  }

  static setFeatureChipsUILists(featureChipsUILists) {
    isFeatureChipsUIListsEnabled = featureChipsUILists
  }
}
